import { z } from 'zod';
import { errorMessage } from './shared';
import {
  isNotAllowSpecialCharProductName,
  isProductNameBlackList,
} from '@modules/MShop/Util/S/Function/util';
import {
  PRODUCT_PRICE__MAX,
  PRODUCT_PRICE__MIN,
} from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/constants.ts';
import {
  spoIntlSchema,
  spoSchema,
} from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/spo.ts';

const productNameSchema = z
  .string()
  .min(3, { message: errorMessage.min_text })
  .max(100, { message: errorMessage.text_length_100 })
  .refine((name) => !isNotAllowSpecialCharProductName(name), {
    message: errorMessage.restrict_character2,
  })
  .refine((name) => !isProductNameBlackList(name), {
    message: errorMessage.black_list_name,
  });

export const productSchema = z.object({
  name: productNameSchema,
  is_public: z.boolean(),
  profit: z
    .number({
      required_error: errorMessage.required,
      invalid_type_error: errorMessage.only_number,
    })
    .int()
    .min(PRODUCT_PRICE__MIN, { message: errorMessage.min_price })
    .max(PRODUCT_PRICE__MAX, { message: errorMessage.max_price }),
  _: z.object({
    spo: spoSchema,
  }),
});

export const ProductIntlSchema = productSchema.extend({
  name_en: productNameSchema,
  name_jp: productNameSchema,
  _: z.object({
    spo: spoIntlSchema,
  }),
});
